module.exports = __webpack_public_path__ + "static/media/7-Spades.a8b10211.svg";